import { Camera, Waves, CarTaxiFront } from "lucide-react";

const SERVICES = [
  {
    icon: Camera,
    name: "Surf Photography",
    desc: "Daily land and water telephoto sessions capturing your best rides at Lagundri Bay and surrounding secret spots.",
  },
  {
    icon: Waves,
    name: "Surf Lessons & Guiding",
    desc: "Experienced local instructors for first-time wave riders in the bay, plus reef line-up guiding for intermediate surfers.",
  },
  {
    icon: CarTaxiFront,
    name: "Binaka Airport Transfers",
    desc: "Direct AC vehicle transfer from Binaka Airport (GNS) directly to Raffiel Nias with roof racks for all board coffins.",
  },
];

const Services = () => (
  <section id="surf-services" className="py-24 bg-sand-50" data-testid="services-section">
    <div className="max-w-7xl mx-auto px-6">
      <div className="text-center max-w-2xl mx-auto mb-16">
        <span className="text-xs font-mono-clean text-ocean-700 uppercase tracking-wider font-semibold">
          Full Surf Experience
        </span>
        <h2 className="font-display text-3xl sm:text-4xl font-bold text-ocean-900 mt-2">
          Everything dialed for your sessions
        </h2>
        <p className="text-sm text-fog mt-3">
          From local reef coaching to crystal-clear water photography and
          airport transit, our on-site team handles all details.
        </p>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        {SERVICES.map((s) => (
          <div key={s.name} className="p-8 rounded-2xl bg-white border border-sand-200 shadow-sm hover:shadow-md transition-shadow">
            <div className="w-10 h-10 rounded-xl bg-ocean-700/10 flex items-center justify-center mb-4">
              <s.icon size={20} className="text-ocean-700" />
            </div>
            <h3 className="font-display text-xl font-bold text-ocean-900 mb-2">{s.name}</h3>
            <p className="text-xs text-fog leading-relaxed">{s.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Services;
